import { NavLink } from "react-router-dom";
import { ROUTES } from "../routes";
import "./app-header.component.css";

const NAV_ITEMS = [
  { to: ROUTES.driverRegistration, label: "Driver Registrations" },
  { to: ROUTES.organizationAdmin, label: "Organization Admin" },
] as const;

export function AppHeader() {
  return (
    <header className="app-header">
      <div className="app-header-brand">LoadHive Admin</div>
      <nav className="app-header-nav" aria-label="Primary">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              isActive ? "app-header-link active" : "app-header-link"
            }
          >
            {item.label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}
